/**
 * The strip that says this is the demo.
 *
 * Every screen behind it is fully populated and fully clickable, which is the
 * point — and also why this has to be visible from the first second. Someone
 * who opens the roster, taps "Add member", fills the form and only THEN meets
 * a refusal has been wasted; someone who read one line first is exploring.
 *
 * It is a statement, not a warning: amber, not crimson. Nothing is wrong.
 */

import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function DemoBanner() {
  const { isDemo } = useAuth();
  if (!isDemo) return null;

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 border-b border-gold-300 bg-gold-50 px-4 py-2.5 sm:px-8">
      <span className="bg-ink-800 px-2 py-[3px] font-market text-[9.5px] font-extrabold uppercase tracking-[0.18em] text-gold-500">
        Demo
      </span>
      <span className="font-market text-[12.5px] leading-snug text-ink-700">
        You are signed in to the example club. Open anything — nothing can be
        added or changed.
      </span>
      <Link
        to="/register-portal"
        className="ml-auto whitespace-nowrap bg-gold-500 px-3 py-1.5 font-market text-[11px] font-extrabold uppercase tracking-[0.12em] text-ink-800 transition-all duration-200 hover:brightness-110"
      >
        Create your portal
      </Link>
    </div>
  );
}
